import { useAtom } from 'jotai';
import { X } from 'lucide-react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

import NpiVerification from '@/app/(secure)/npi-verification';
import { Icon } from '@/components/ui/icon';
import {
  Modal,
  ModalBackdrop,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
} from '@/components/ui/modal';
import { useBreakpointValue } from '@/components/ui/utils/use-break-point-value';
import { communityShowAuthModalAtom } from '@/services/globalState';

export type NpiVerificationModalProps = {
  isOpen?: boolean;
};

/**
 * Modal component for NPI verification flow
 *
 * Renders the NPI verification process within a modal overlay,
 * allowing users to complete verification without navigation.
 */
export function NpiVerificationModal({ isOpen }: NpiVerificationModalProps) {
  const [, setShowAuthModal] = useAtom(communityShowAuthModalAtom);

  const modalSize =
    useBreakpointValue({
      default: 'md',
      md: 'md',
    }) || 'md';

  const insets = useSafeAreaInsets();

  return (
    <Modal isOpen={isOpen} size={modalSize} onClose={() => setShowAuthModal(false)}>
      <ModalBackdrop />

      <ModalContent
        className="w-[90%] max-w-[500px] self-center"
        style={{
          marginTop: insets.top || 20,
          marginBottom: insets.bottom || 20,
          marginHorizontal: 0,
        }}>
        <ModalHeader className="justify-end">
          <ModalCloseButton onPress={() => setShowAuthModal(false)}>
            <Icon as={X} size="md" />
          </ModalCloseButton>
        </ModalHeader>

        <ModalBody>
          <NpiVerification inModal />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
